import BreadCrumb, { partnerWithUsBg } from '../components/BreadCrumb.jsx';
import BenifitsOfPartnership from '../components/BenifitsOfPartnership.jsx';
import PartnerWithUsForm from '../components/PartnerWithUsForm.jsx';
import WhyUs from '../components/WhyUs.jsx';

function PartnerWithUs() {

    return (
        <>
            <BreadCrumb
                backgroundImage={partnerWithUsBg}
                title={"Partner With Us"}
                description={"Network with our 3000+ CISOs, CIOs and cyber security leaders with our partner programs."}
            />
            <WhyUs />
            <BenifitsOfPartnership />
            <PartnerWithUsForm />
        </>
    )
}

export default PartnerWithUs